import { render, staticRenderFns } from "./Splash.vue?vue&type=template&id=12cad394&"
import script from "./Splash.vue?vue&type=script&lang=ts&"
export * from "./Splash.vue?vue&type=script&lang=ts&"
import style0 from "./Splash.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports